module.exports = __webpack_public_path__ + "img/SC8-Member_type.3d0cec1a.svg";